import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/studio/animation/animationInput.css";
import {
  getAnimation,
  getAnimations,
} from "../../services/animation.service.js";

const AnimationInput = ({
  animationId,
  setAnimationId,
  isLoading,
  setIsLoading,
}) => {
  const [animations, setAnimations] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!isOpen) return;

    const fetchAnimations = async () => {
      setIsLoading(true);
      try {
        const data = await getAnimations({ page: 1, limit: 10 });
        setAnimations(data.records || []);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAnimations();
  }, [isOpen]);

  const handleSelect = (id) => {
    setAnimationId(id);
    setIsOpen(false);
  };

  return (
    <div className="animation-input">
      <label className="animation-label">
        Animation <span className="required">*</span>
      </label>

      <div className="animation-actions">
        <button
          type="button"
          className="btn secondary"
          onClick={() => setIsOpen((prev) => !prev)}
          disabled={isLoading}
        >
          {animationId ? "Change Animation" : "Select Animation"}
        </button>

        <button
          type="button"
          className="btn primary"
          onClick={() => navigate("/studio/animations/new")}
          disabled={isLoading}
        >
          Create Animation
        </button>
      </div>

      {animationId && (
        <div className="selected-animation">
          Selected animation ID: <span>{animationId}</span>
        </div>
      )}

      {isOpen && (
        <div className="animation-list">
          {isLoading && <div className="loading">Loading animations…</div>}

          {!isLoading && animations.length === 0 && (
            <div className="empty">No animations found</div>
          )}

          {!isLoading &&
            animations.map((anim) => (
              <div
                key={anim.animationId}
                className={`animation-item ${
                  anim.animationId === animationId ? "active" : ""
                }`}
                onClick={() => handleSelect(anim.animationId)}
              >
                <div className="title">{anim.title}</div>
                <div className="meta">Duration: {anim.duration}s</div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default AnimationInput;
